import React from "react";

import styles from "./AchievementRate.module.scss";

export interface IAchievementRateProps {
  achieved: number;
  total: number;
}
const AchievementRate: React.FC<IAchievementRateProps> = ({
  achieved,
  total,
}) => {
  const percentage = total > 0 ? (achieved / total) * 100 : 0;
  const radius = 20;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className={styles.progressContainer}>
      <span className={styles.title}>達成度</span>
      <div className={styles.progressInfo}>
        <div className={styles.count}>
          <span className={styles.achieved}>{achieved}</span>
          <span className={styles.line}>/</span>
          <span className={styles.total}>{total}</span>
        </div>
        <svg
          width="40"
          height="40"
          viewBox="0 0 50 50"
          className={styles.progressSvg}
        >
          <circle
            className={styles.backgroundCircle}
            cx="25"
            cy="25"
            r={radius}
            strokeWidth="2.5"
          />
          <circle
            className={styles.progressCircle}
            cx="25"
            cy="25"
            r={radius}
            strokeWidth="2.5"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
          <text x="50%" y="50%" className={styles.percentageText}>
            <tspan className={styles.percentageNumber}>
              {Math.round(percentage)}
            </tspan>
            <tspan className={styles.percentageSymbol}>%</tspan>
          </text>
        </svg>
      </div>
    </div>
  );
};

export default AchievementRate;
